/* Keep cards consistent with the server-rendered branded product galleries. */
(() => {
  const updateCards = () => {
    document.querySelectorAll('.card-wrapper a[href*="/products/"]').forEach(link => {
      const handle = new URL(link.href).pathname.split('/products/')[1]?.split('/')[0];
      const source = window.BVProductAssets?.[handle];
      const card = link.closest('.card-wrapper');
      const image = card?.querySelector('.card__media img');
      if (!source || !image || image.dataset.bvBranded) return;
      image.src = source;
      image.srcset = '';
      image.dataset.bvBranded = 'true';
      card.querySelectorAll('.card__media img:not([data-bv-branded])').forEach(other => other.remove());
    });
  };
  const init = () => {
    updateCards();
    new MutationObserver(updateCards).observe(document.body, {childList:true, subtree:true});
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init, {once:true}) : init();
})();
